import { render, staticRenderFns } from "./MedicalRecord.vue?vue&type=template&id=6cedb73b&scoped=true"
import script from "./MedicalRecord.vue?vue&type=script&lang=js"
export * from "./MedicalRecord.vue?vue&type=script&lang=js"
import style0 from "./MedicalRecord.vue?vue&type=style&index=0&id=6cedb73b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cedb73b",
  null
  
)

export default component.exports